import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'lib-opportunity',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './opportunity.component.html',
  styleUrls: ['./opportunity.component.scss'],
})
export class OpportunityComponent {}
